// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"348":"72b4351cca10805a2236","781":"f5fd5840006f8d948782","885":"b9c712fb857cc5c1c7ac"}[chunkId] + ".js";
};